/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pr_Type_TimeInputs */

const fr_pr_type_time = /** @type {(inputs: Pr_Type_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps`)
};

/**

* @param {Pr_Type_TimeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pr_type_time = /** @type {((inputs?: Pr_Type_TimeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pr_Type_TimeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pr_type_time(inputs)
});